// Phase 8 Plan 03 Task 1 — per-template walker for the `static-note` template.
//
// Pure TS — no React, no DOM. Server-friendly: Phase 10 AI prompt-gen + Phase 13 SSR
// re-import from here. Hand-written per RESEARCH §"Pattern 2 Option A".
//
// configSchema source mirrored verbatim (../../schemas/widget-templates/static-note.ts):
//   body: string
//   tone: 'info' | 'warning' | 'note' (default 'info')
//
// Walker output: kind:'group' root + two leaves. Smallest possible walker — this
// is the docs walkthrough target (`docs/ADD-A-TEMPLATE.md`).

import type { FieldDescriptor } from "../descriptors.js";

export function walkStaticNoteConfig(configPath: string): FieldDescriptor {
  return {
    kind: "group",
    name: "config",
    path: configPath,
    children: [
      {
        kind: "leaf",
        name: "body",
        path: `${configPath}.body`,
        type: "string",
        required: true,
      },
      {
        kind: "leaf",
        name: "tone",
        path: `${configPath}.tone`,
        type: "enum",
        required: true,
        enumValues: [
          { id: "info", label: "Info" },
          { id: "warning", label: "Warning" },
          { id: "note", label: "Note" },
        ],
      },
    ],
  };
}
